// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c871e1c0","667":"4fcaf4e4","977":"e3334a19"}[chunkId] + ".chunk.js";
};